// import React, {useState} from 'react';
// import css from './check-in.module.css';
// import { axiosImageAuthFetch, axiosAuthFetch } from '../../../../helpers/axios';
// import { API_BASE_URL } from '../../../../constants';
// import Loader from '../../loader
// import CustomAlertModal from '../../customModal';

// const StarRating = ({ rating, setRating }) => {
//     const handleRating = (index) => {
//         setRating(index + 1);
//     }

//     return (
//         <div className={css.stars}>
//             {[...Array(5)].map((star, index) => {
//                 return (
//                     <span
//                         key={index}
//                         className={`${css.star} ${index < rating ? css.filled : ''}`}
//                         onClick={() => handleRating(index)}
//                     >
//                         ★
//                     </span>
//                 );
//             })}
//         </div>
//     );
// };

// const NewCheckIn = ({ user }) => {
//     const userId = user.id;
//     const [weight, setWeight] = useState('');
//     const [comment, setComment] = useState('');
//     const [images, setImages] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [isError, setIsError] = useState(false);
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [sleepRating, setSleepRating] = useState(3);
//     const [nutritionRating, setNutritionRating] = useState(3);
//     const [motivationalRating, setMotivationalRating] = useState(3);
//     const [trainingRating, setTrainingRating] = useState(3);

//     // const handleSubmit = async () => {
//     //     setIsLoading(true);

//     //     let formattedWeight = weight.replace(',', '.');
//     //     let weightValue = parseFloat(formattedWeight);

//     //     // Valider at vekten er et gyldig tall
//     //     if (isNaN(weightValue)) {
//     //     alert('Vennligst skriv inn en gyldig vekt');
//     //     setIsLoading(false);
//     //     return;
//     //     }

//     //     // Formatere vekten til én desimal
//     //     weightValue = parseFloat(weightValue.toFixed(1));


//     //     //const formattedWeight = weight.replace(',','.');
//     //     const formData = new FormData();
//     //     formData.append('data', JSON.stringify({
//     //         client: userId,
//     //         weight: weightValue,
//     //         comment,
//     //         rating_training: trainingRating,
//     //         rating_nutrition: nutritionRating,
//     //         rating_motivation: motivationalRating,
//     //         rating_sleep: sleepRating,
//     //         date: new Date(),
//     //     }));

//     //     images.forEach((image, index) => {
//     //         formData.append('files.progress_pic', image);
//     //     });

//     //     try {
//     //         const response = await axiosImageAuthFetch(`${API_BASE_URL}/check-ins`, formData);
//     //         console.log(response);
//     //         alert('Check-in submitted successfully');
//     //         setIsLoading(false);
//     //         setIsModalOpen(false); // Close modal on successful submission
//     //     } catch (error) {
//     //         console.error(error);
//     //         setIsLoading(false);
//     //         setIsError(true);
//     //     }
//     // }

//     const handleSubmit = async () => {
//         setIsLoading(true);
      
//         // Konverter og valider vekt
//         let formattedWeight = weight.replace(',', '.');
//         let weightValue = parseFloat(formattedWeight);
//         if (isNaN(weightValue)) {
//           alert('Vennligst skriv inn en gyldig vekt');
//           setIsLoading(false);
//           return;
//         }
//         weightValue = parseFloat(weightValue.toFixed(1));
      
//         // 1. Last opp bildene via Strapi sitt upload-endepunkt
//         let uploadedFiles = [];
//         if (images && images.length > 0) {
//           const uploadFormData = new FormData();
//           images.forEach((image) => {
//             // Bruk feltet 'files' – Strapi forventer ofte dette
//             uploadFormData.append('files', image);
//           });
//           try {
//             // Bruk gjerne axiosImageAuthFetch (en variant av axios med riktig konfigurasjon for opplastning)
//             const uploadResponse = await axiosImageAuthFetch(`${API_BASE_URL}/upload`, uploadFormData);
//             console.log("Upload response:", uploadResponse.data);
//             // Anta at responsen er et array med opplastede filobjekter
//             uploadedFiles = uploadResponse.data;
//           } catch (error) {
//             console.error("Feil ved opplasting av bilder:", error);
//             setIsLoading(false);
//             return;
//           }
//         }
      
//         // 2. Ekstraher fil-IDer fra opplastingsresponsen
//         const fileIds = uploadedFiles.map((file) => file.id);
//         // Du kan også legge til ekstra logging:
//         console.log("Opplastede fil-IDer:", fileIds);
      
//         // 3. Opprett check-in posten med en JSON-payload som inkluderer fil-IDene
//         const checkInPayload = {
//           data: {
//             client: userId,  // ID til klienten (bruker-ID)
//             weight: weightValue,
//             comment,
//             rating_training: trainingRating,
//             rating_nutrition: nutritionRating,
//             rating_motivation: motivationalRating,
//             rating_sleep: sleepRating,
//             date: new Date(),
//             // Legg til filreferansen til bildet/bildene, antatt at feltet heter "progress_pic" i check-in-modellen
//             progress_pic: fileIds,
//           },
//         };
      
//         try {
//           // Bruk vanlig axiosAuthFetch for å sende en JSON-kall til check-ins-endepunktet
//           const response = await axiosAuthFetch(`${API_BASE_URL}/check-ins`, checkInPayload, 'POST');
//           console.log("Check-in opprettet:", response.data);
//           alert('Check-in submitted successfully');
//           setIsLoading(false);
//           setIsModalOpen(false); // Lukker modalen ved suksess
//         } catch (error) {
//           console.error("Feil ved opprettelse av check-in:", error);
//           setIsLoading(false);
//           setIsError(true);
//         }
//       };
      

//     const handleImageChange = (e) => {
//         setImages([...e.target.files]);
//     }

//     const openModal = () => {
//         setIsModalOpen(true);
//     }

//     const closeModal = () => {
//         setIsModalOpen(false);
//     }

//     const handleWeightChange = (e) => {
//         let value = e.target.value;
//         // Erstatt komma med punktum
//         value = value.replace(',', '.');
    
//         // Tillat kun tall og ett punktum
//         if (!/^\d*\.?\d*$/.test(value)) {
//           // Ugyldig inndata, ignorer endringen
//           return;
//         }
//         if (value.includes('.')) {
//             //eslint-disable-next-line
//             const [integerPart, decimalPart] = value.split('.');
//             if (decimalPart.length > 1) {
//               // Hvis mer enn én desimal, ignorer endringen
//               return;
//             }
//           }
      
//           setWeight(value);
//         };
    

//     if (isLoading) {
//         return (<Loader />);
//     }
//     if (isError) {
//         return (
//             <div>Oida, her gikk noe galt! Vennligst prøv å last inn siden på nytt!</div>
//         );
//     }

//     return (
//         <div className={css.container}>
//             <button className={css.submitButton} onClick={openModal}>Ny Check-In</button>
//             <CustomAlertModal
//                 show={isModalOpen}
//                 handleClose={closeModal}
//                 content={
//                     <form className={css.form}>
//                         <div className={css.weightInput}>
//                             <label>Vekt (i kg)</label>
//                             <input className={css.weightInputfield} type="text" inputMode='decimal' value={weight} onChange={handleWeightChange} required />
//                         </div>
//                         <div className={css.inputRating}>
//                             <label>Søvn</label>
//                             <StarRating rating={sleepRating} setRating={setSleepRating} />
//                         </div>
//                         <div className={css.inputRating}>
//                             <label>Trening</label>
//                             <StarRating rating={trainingRating} setRating={setTrainingRating} />
//                         </div>
//                         <div className={css.inputRating}>
//                             <label>Kosthold</label>
//                             <StarRating rating={nutritionRating} setRating={setNutritionRating} />
//                         </div>
//                         <div className={css.inputRating}>
//                             <label>Motivasjon</label>
//                             <StarRating rating={motivationalRating} setRating={setMotivationalRating} />
//                         </div>
//                         <div className={css.commentInput}>
//                             <label>Kommentar</label>
//                             <textarea rows="5" className={css.inputInput} type="input" value={comment} onChange={(e) => setComment(e.target.value)} />
//                         </div>
//                         <div className={css.imageInput}>
//                             <label>Last opp bilder:</label>
//                             <input type="file" multiple onChange={handleImageChange} />
//                         </div>
//                         <div className={css.submitButton} onClick={handleSubmit}>SEND INN</div>
//                     </form>
//                 }
//                 submit={handleSubmit}
//                 modalTitle="Hvordan har din uke vært?"
//             />
//         </div>
//     );
// }

// export default NewCheckIn;




// import React, { useState } from 'react';
// import css from './check-in.module.css';
// import { axiosImageAuthFetch, axiosAuthFetch } from '../../../../helpers/axios';
// import { API_BASE_URL } from '../../../../constants';
// import Loader from '../../loader';
// import CustomAlertModal from '../../customModal';

// const StarRating = ({ rating, setRating }) => {
//   const handleRating = (index) => setRating(index + 1);

//   return (
//     <div className={css.stars}>
//       {[...Array(5)].map((_, index) => (
//         <span
//           key={index}
//           className={`${css.star} ${index < rating ? css.filled : ''}`}
//           onClick={() => handleRating(index)}
//           role="button"
//           tabIndex={0}
//           onKeyDown={(e) => {
//             if (e.key === 'Enter' || e.key === ' ') handleRating(index);
//           }}
//           aria-label={`Sett rating til ${index + 1} av 5`}
//         >
//           ★
//         </span>
//       ))}
//     </div>
//   );
// };

// const NewCheckIn = ({ user }) => {
//   const userId = user.id;

//   const [weight, setWeight] = useState('');
//   const [comment, setComment] = useState('');
//   const [images, setImages] = useState([]);

//   const [isLoading, setIsLoading] = useState(false);
//   const [isError, setIsError] = useState(false);

//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const [sleepRating, setSleepRating] = useState(3);
//   const [nutritionRating, setNutritionRating] = useState(3);
//   const [motivationalRating, setMotivationalRating] = useState(3);
//   const [trainingRating, setTrainingRating] = useState(3);

//   const openModal = () => {
//     setIsError(false);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     // CustomAlertModal (A-versjonen) blokkerer allerede lukking under submit,
//     // men vi holder dette enkelt her.
//     setIsModalOpen(false);
//   };

//   const resetForm = () => {
//     setWeight('');
//     setComment('');
//     setImages([]);
//     setSleepRating(3);
//     setNutritionRating(3);
//     setMotivationalRating(3);
//     setTrainingRating(3);
//   };

//   const handleImageChange = (e) => {
//     setImages([...e.target.files]);
//   };

//   const handleWeightChange = (e) => {
//     let value = e.target.value;
//     value = value.replace(',', '.');

//     // Tillat kun tall og ett punktum
//     if (!/^\d*\.?\d*$/.test(value)) return;

//     // Max én desimal
//     if (value.includes('.')) {
//       const [, decimalPart] = value.split('.');
//       if (decimalPart && decimalPart.length > 1) return;
//     }

//     setWeight(value);
//   };

//   /**
//    * IMPORTANT:
//    * Returnerer true => modal lukker (CustomAlertModal gjør handleClose)
//    * Returnerer false => modal forblir åpen (validering/feil)
//    */
//   const handleSubmit = async () => {
//     if (isLoading) return false; // hard guard
//     setIsError(false);
//     setIsLoading(true);

//     try {
//       // Valider vekt
//       const formattedWeight = (weight || '').replace(',', '.').trim();
//       let weightValue = parseFloat(formattedWeight);

//       if (Number.isNaN(weightValue)) {
//         alert('Vennligst skriv inn en gyldig vekt');
//         return false; // ikke lukk modal
//       }

//       weightValue = parseFloat(weightValue.toFixed(1));

//       // 1) Upload bilder (valgfritt)
//       let uploadedFiles = [];
//       if (images && images.length > 0) {
//         const uploadFormData = new FormData();
//         images.forEach((image) => uploadFormData.append('files', image));

//         const uploadResponse = await axiosImageAuthFetch(
//           `${API_BASE_URL}/upload`,
//           uploadFormData
//         );

//         // Axios helper kan returnere enten array eller {data: array}
//         const filesArray = uploadResponse?.data ?? uploadResponse;
//         uploadedFiles = Array.isArray(filesArray) ? filesArray : [];
//       }

//       const fileIds = uploadedFiles.map((file) => file.id);

//       // 2) Opprett check-in
//       const checkInPayload = {
//         data: {
//           client: userId,
//           weight: weightValue,
//           comment,
//           rating_training: trainingRating,
//           rating_nutrition: nutritionRating,
//           rating_motivation: motivationalRating,
//           rating_sleep: sleepRating,
//           date: new Date(),
//           progress_pic: fileIds, // multiple media => array med IDs
//         },
//       };

//       await axiosAuthFetch(`${API_BASE_URL}/check-ins`, checkInPayload, 'POST');

//       // Suksess: reset form. Modalen lukkes av CustomAlertModal etter await.
//       resetForm();
//       return true;
//     } catch (error) {
//       console.error('Feil ved opprettelse av check-in:', error);
//       setIsError(true);
//       return false; // behold modal åpen, så brukeren ser at det feilet
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   if (isLoading && !isModalOpen) {
//     return <Loader />;
//   }

//   return (
//     <div className={css.container}>
//       <button className={css.submitButton} onClick={openModal}>
//         Ny Check-In
//       </button>

//       <CustomAlertModal
//         show={isModalOpen}
//         handleClose={closeModal}
//         modalTitle="Hvordan har din uke vært?"
//         buttonLabel={isLoading ? 'Sender…' : 'Send inn'}
//         submit={handleSubmit}
//         content={
//           <div className={css.form}>
//             <div className={css.weightInput}>
//               <label>Vekt (i kg)</label>
//               <input
//                 className={css.weightInputfield}
//                 type="text"
//                 inputMode="decimal"
//                 value={weight}
//                 onChange={handleWeightChange}
//                 required
//                 disabled={isLoading}
//               />
//             </div>

//             <div className={css.inputRating}>
//               <label>Søvn</label>
//               <StarRating rating={sleepRating} setRating={setSleepRating} />
//             </div>
//             <div className={css.inputRating}>
//               <label>Trening</label>
//               <StarRating rating={trainingRating} setRating={setTrainingRating} />
//             </div>
//             <div className={css.inputRating}>
//               <label>Kosthold</label>
//               <StarRating rating={nutritionRating} setRating={setNutritionRating} />
//             </div>
//             <div className={css.inputRating}>
//               <label>Motivasjon</label>
//               <StarRating
//                 rating={motivationalRating}
//                 setRating={setMotivationalRating}
//               />
//             </div>

//             <div className={css.commentInput}>
//               <label>Kommentar</label>
//               <textarea
//                 rows="5"
//                 className={css.inputInput}
//                 value={comment}
//                 onChange={(e) => setComment(e.target.value)}
//                 disabled={isLoading}
//               />
//             </div>

//             <div className={css.imageInput}>
//               <label>Last opp bilder:</label>
//               <input
//                 type="file"
//                 multiple
//                 onChange={handleImageChange}
//                 disabled={isLoading}
//               />
//             </div>

//             {isError && (
//               <div style={{ marginTop: 8 }}>
//                 Oida – noe gikk galt. Prøv igjen.
//               </div>
//             )}

//             {/* Ingen SEND INN knapp her inne – kun modalens footer-knapp */}
//             <div style={{ marginTop: 10, fontSize: 12, opacity: 0.7 }}>
//               Når du trykker “Send inn” kan det ta et par sekunder – spesielt hvis du laster opp bilder.
//             </div>
//           </div>
//         }
//       />
//     </div>
//   );
// };

// export default NewCheckIn;


// const CheckInForm = ({ user, coachId, checkIns }) => {
//     const userId = user.id;
//     console.log(user);
//     const [weight, setWeight] = useState('');
//     const [comment, setComment] = useState('');
//     const [images, setImages] = useState([]);
//      const [isLoading, setIsLoading] = useState(false);
//     // const [isError, setIsError] = useState(false);
//     // const [isModalOpen, setIsModalOpen] = useState(false);
//     const [sleepRating, setSleepRating] = useState(3);
//     const [nutritionRating, setNutritionRating] = useState(3);
//     const [motivationalRating, setMotivationalRating] = useState(3);
//     const [trainingRating, setTrainingRating] = useState(3);

//     const now = new Date();
//     const startOfWeek = new Date(now.setDate(now.getDate() - now.getDay() + 1)); // Mandag som startdag
//     startOfWeek.setHours(0, 0, 0, 0);
//     const endOfWeek = new Date(startOfWeek);
//     endOfWeek.setDate(endOfWeek.getDate() + 6);
//     endOfWeek.setHours(23, 59, 59, 999);

//     // const hasCheckInThisWeek = checkIns.some((checkIn) => {
//     //     const checkInDate = new Date(checkIn.attributes.date);
//     //     return checkInDate >= startOfWeek && checkInDate <= endOfWeek;
//     // });

//     const handleSubmit = async () => {
//         // if (hasCheckInThisWeek) {
//         //     alert("Du har allerede sendt inn en check-in denne uken.");
//         //     return;
//         // }
        
//         setIsLoading(true);

//         let formattedWeight = weight.replace(',', '.');
//         let weightValue = parseFloat(formattedWeight);

//         // Valider at vekten er et gyldig tall
//         if (isNaN(weightValue)) {
//         alert('Vennligst skriv inn en gyldig vekt');
//         //setIsLoading(false);
//         setIsLoading(false);
//         return;
//         }

//         // Formatere vekten til én desimal
//         weightValue = parseFloat(weightValue.toFixed(1));


//         //const formattedWeight = weight.replace(',','.');
//         const formData = new FormData();
//         formData.append('data', JSON.stringify({
//             client: userId,
//             weight: weightValue,
//             comment,
//             coach: coachId,
//             rating_training: trainingRating,
//             rating_nutrition: nutritionRating,
//             rating_motivation: motivationalRating,
//             rating_sleep: sleepRating,
//             date: new Date(),
//         }));

//         images.forEach((image, index) => {
//             formData.append('files.progress_pic', image);
//         });

//         try {
//             const response = await axiosImageAuthFetch(`${API_BASE_URL}/check-ins`, formData);
//             console.log(response);
//             alert('✅ Check-in submitted successfully');
//             setIsLoading(false);
//             window.location.reload();
//             // setIsModalOpen(false); // Close modal on successful submission
//         } catch (error) {
//             console.error(error);
//              setIsLoading(false);
//             // setIsError(true);
//         }
//     }

//     // const handleSubmit = async () => {
//     //     if (hasCheckInThisWeek) {
//     //       alert("Du har allerede sendt inn en check-in denne uken.");
//     //       return;
//     //     }
        
//     //     setIsLoading(true);
      
//     //     // Konverter og valider vekt
//     //     let formattedWeight = weight.replace(',', '.');
//     //     let weightValue = parseFloat(formattedWeight);
//     //     if (isNaN(weightValue)) {
//     //       alert('Vennligst skriv inn en gyldig vekt');
//     //       setIsLoading(false);
//     //       return;
//     //     }
//     //     weightValue = parseFloat(weightValue.toFixed(1));
      
        
//     //     let uploadedFileIds = [];
//     //     if (images && images.length > 0) {
//     //       const uploadFormData = new FormData();
         
//     //       images.forEach((image) => {
//     //         uploadFormData.append('files', image);
//     //       });
          
//     //       try {
            
//     //         const uploadResponse = await axiosImageAuthFetch(`${API_BASE_URL}/upload`, uploadFormData);
//     //         console.log("Upload response:", JSON.stringify(uploadResponse, null, 2));
            
//     //         const filesArray = uploadResponse.data ? uploadResponse.data : uploadResponse;
//     //         if (!filesArray || !Array.isArray(filesArray)) {
//     //             console.error("Ingen fildata mottatt fra opplastningen");
//     //             setIsLoading(false);
//     //             return;
//     //         }
            
//     //         const uploadedFileIds = filesArray.map((file) => file.id);
//     //         console.log("Opplastede fil-IDer:", uploadedFileIds);
//     //       } catch (error) {
//     //         console.error("Feil ved opplasting av bilder:", error.response ? error.response.data : error);
//     //         setIsLoading(false);
//     //         return;
//     //       }
//     //     }
      
//     //     // 2. Opprett check-in med en JSON-payload som inkluderer referansen til de opplastede bildene.
//     //     // Sørg for at feltet "progress_pic" i modellen din forventer en array med fil-IDer.
//     //     const checkInPayload = {
//     //       data: {
//     //         client: userId,
//     //         weight: weightValue,
//     //         comment,
//     //         rating_training: trainingRating,
//     //         rating_nutrition: nutritionRating,
//     //         rating_motivation: motivationalRating,
//     //         rating_sleep: sleepRating,
//     //         date: new Date(),
//     //         progress_pic: uploadedFileIds,  // Her sender du referansen til de opplastede bildene
//     //       },
//     //     };
      
//     //     console.log("Check-in payload:", JSON.stringify(checkInPayload, null, 2));
      
//     //     try {
//     //       // Bruk en vanlig axios-kall (JSON) for å opprette check-in
//     //       const response = await axiosAuthFetch(`${API_BASE_URL}/check-ins`, checkInPayload, 'POST');
//     //       console.log("Check-in opprettet:", response);
//     //       alert('Check-in submitted successfully');
//     //       setIsLoading(false);
//     //       window.location.reload();
//     //     } catch (error) {
//     //       console.error("Feil ved opprettelse av check-in:", error.response ? error.response.data : error);
//     //       setIsLoading(false);
//     //     }
//     //   };
      

//     const handleImageChange = (e) => {
//         setImages([...e.target.files]);
//     }

//     const handleWeightChange = (e) => {
//         let value = e.target.value;
//         // Erstatt komma med punktum
//         value = value.replace(',', '.');
    
//         // Tillat kun tall og ett punktum
//         if (!/^\d*\.?\d*$/.test(value)) {
//           // Ugyldig inndata, ignorer endringen
//           return;
//         }
//         if (value.includes('.')) {
//             //eslint-disable-next-line
//             const [integerPart, decimalPart] = value.split('.');
//             if (decimalPart.length > 1) {
//               // Hvis mer enn én desimal, ignorer endringen
//               return;
//             }
//           }
      
//           setWeight(value);
//         };

//         // if (isLoading) {
//         //     return (<Loader />);
//         // }

//         const LoadingOverlay = () => (
//             <div
//                 style={{
//                 position: 'absolute',
//                 inset: 0,
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 background: 'rgba(255,255,255,0.75)',
//                 zIndex: 10,
//                 borderRadius: 12,
//                 }}
//             >
//                 <Loader />
//             </div>
//             );


//         return(
//             <div style={{ position: 'relative' }}>
//                 {isLoading && <LoadingOverlay />}
//             <form className={css.form}>
//                 <h2>Ny Check-In</h2>
//                         <div className={css.weightInput}>
//                             <label>Vekt (i kg)</label>
//                             <input className={css.weightInputfield} type="text" inputMode='decimal' value={weight} onChange={handleWeightChange} required />
//                         </div>
//                         <div className={css.inputRating}>
//                             <label>Søvn</label>
//                             <StarRating rating={sleepRating} setRating={setSleepRating} />
//                         </div>
//                         <div className={css.inputRating}>
//                             <label>Trening</label>
//                             <StarRating rating={trainingRating} setRating={setTrainingRating} />
//                         </div>
//                         <div className={css.inputRating}>
//                             <label>Kosthold</label>
//                             <StarRating rating={nutritionRating} setRating={setNutritionRating} />
//                         </div>
//                         <div className={css.inputRating}>
//                             <label>Motivasjon</label>
//                             <StarRating rating={motivationalRating} setRating={setMotivationalRating} />
//                         </div>
//                         <div className={css.commentInput}>
//                             <label>Kommentar</label>
//                             <textarea rows="5" className={css.inputInput} type="input" value={comment} onChange={(e) => setComment(e.target.value)} />
//                         </div>
//                         <div className={css.imageInput}>
//                             <label>Last opp bilder:</label>
//                             <input type="file" multiple onChange={handleImageChange} />
//                         </div>
//                         <div className={css.submitButton} onClick={handleSubmit}>SEND INN</div>
//                     </form>
//                 </div>
//         )
// }

// export { CheckInForm };

// import React, { useState } from 'react';
// import css from './check-in.module.css';
// import { axiosImageAuthFetch, axiosAuthFetch } from '../../../../helpers/axios';
// import { API_BASE_URL } from '../../../../constants';
// import Loader from '../../loader';
// import CustomAlertModal from '../../customModal';

// import Resizer from 'react-image-file-resizer';

// // ---------------------------------------------------------------------------
// // Helpers
// // ---------------------------------------------------------------------------

// // ---------------------------------------------------------------------------
// // Image compression helpers
// // ---------------------------------------------------------------------------

// function resizeToJpegFile(file, { maxW = 1400, maxH = 1400, quality = 80 } = {}) {
//   return new Promise((resolve, reject) => {
//     try {
//       Resizer.imageFileResizer(
//         file,
//         maxW,
//         maxH,
//         'JPEG',
//         quality,
//         0,
//         (uri) => {
//           // uri kan være File eller base64 avhengig av config.
//           // Vi ber om File i siste param.
//           resolve(uri);
//         },
//         'file',
//         file.name?.replace(/\.\w+$/, '') || 'image'
//       );
//     } catch (e) {
//       reject(e);
//     }
//   });
// }

// async function compressImages(images, opts) {
//   if (!images || images.length === 0) return [];
//   // Komprimer parallelt
//   return Promise.all(images.map((f) => resizeToJpegFile(f, opts)));
// }

// const StarRating = ({ rating, setRating, disabled }) => (
//   <div className={css.stars}>
//     {[...Array(5)].map((_, index) => (
//       <span
//         key={index}
//         className={`${css.star} ${index < rating ? css.filled : ''}`}
//         onClick={() => !disabled && setRating(index + 1)}
//         role="button"
//         tabIndex={disabled ? -1 : 0}
//         onKeyDown={(e) => {
//           if (!disabled && (e.key === 'Enter' || e.key === ' ')) setRating(index + 1);
//         }}
//         aria-label={`Sett rating til ${index + 1} av 5`}
//       >
//         ★
//       </span>
//     ))}
//   </div>
// );

// /** Validerer og parser vektstreng. Kaster Error med norsk melding ved ugyldig input. */
// function parseWeight(rawValue) {
//   const str = (rawValue ?? '').replace(',', '.').trim();
//   const num = parseFloat(str);
//   if (!str || isNaN(num) || num <= 0) {
//     throw new Error('Vennligst skriv inn en gyldig vekt (f.eks. 82.5)');
//   }
//   return parseFloat(num.toFixed(1));
// }

// /** Håndterer bildeopplasting og returnerer array med fil-IDer (kan være tom). */
// // async function uploadImages(images) {
// //   if (!images || images.length === 0) return [];

// //   const uploadFormData = new FormData();
// //   images.forEach((img) => uploadFormData.append('files', img));

// //   const uploadResponse = await axiosImageAuthFetch(`${API_BASE_URL}/upload`, uploadFormData, 'POST');

// //   // axiosImageAuthFetch kan returnere enten array eller { data: array }
// //   const filesArray = Array.isArray(uploadResponse)
// //     ? uploadResponse
// //     : Array.isArray(uploadResponse?.data)
// //     ? uploadResponse.data
// //     : [];

// //   return filesArray.map((f) => f.id);
// // }

// /** Håndterer bildeopplasting (med komprimering) og returnerer array med fil-IDer (kan være tom). */
// // async function uploadImages(images, {
// //   onProgress,                // (pct: number) => void
// //   compress = true,
// //   compressOptions = { maxW: 1400, maxH: 1400, quality: 80 },
// // } = {}) {
// //   if (!images || images.length === 0) return [];

// //   onProgress?.(0);

// //   // 1) Komprimer (parallelt)
// //   const finalFiles = compress
// //     ? await compressImages(images, compressOptions)
// //     : images;

// //   // 2) 1 request til /upload (best: “samtidig” upload av alle)
// //   const uploadFormData = new FormData();
// //   finalFiles.forEach((img) => uploadFormData.append('files', img));

// //   const uploadResponse = await axiosImageAuthFetch(
// //     `${API_BASE_URL}/upload`,
// //     uploadFormData,
// //     'POST',
// //     {
// //       onUploadProgress: (evt) => {
// //         if (!evt.total) return;
// //         const pct = Math.round((evt.loaded / evt.total) * 100);
// //         onProgress?.(pct);
// //       },
// //     }
// //   );

// //   const filesArray = Array.isArray(uploadResponse)
// //     ? uploadResponse
// //     : Array.isArray(uploadResponse?.data)
// //     ? uploadResponse.data
// //     : [];

// //   onProgress?.(100);
// //   return filesArray.map((f) => f.id);
// // }

// async function uploadImages(images, {
//   onProgress,
//   onCompress,  // ny callback
//   compress = true,
//   compressOptions = { maxW: 1400, maxH: 1400, quality: 80 },
// } = {}) {
//   if (!images || images.length === 0) return [];

//   // 1) Komprimer
//   onCompress?.();
//   const finalFiles = compress
//     ? await compressImages(images, compressOptions)
//     : images;

//   // 2) Last opp
//   onProgress?.(0);
//   const uploadFormData = new FormData();
//   finalFiles.forEach((img) => uploadFormData.append('files', img));

//   const uploadResponse = await axiosImageAuthFetch(
//     `${API_BASE_URL}/upload`,
//     uploadFormData,
//     'POST',
//     {
//       onUploadProgress: (evt) => {
//         if (!evt.total) return;
//         const pct = Math.round((evt.loaded / evt.total) * 100);
//         onProgress?.(pct);
//       },
//     }
//   );

//   const filesArray = Array.isArray(uploadResponse)
//     ? uploadResponse
//     : Array.isArray(uploadResponse?.data)
//     ? uploadResponse.data
//     : [];

//   onProgress?.(100);
//   return filesArray.map((f) => f.id);
// }

// // ---------------------------------------------------------------------------
// // CheckInForm – brukes fra profil-siden (BottomSheetModal)
// // ---------------------------------------------------------------------------

// export const CheckInForm = ({ user, coachId, checkIns, onSuccess }) => {
//   const userId = user.id;

//   const [weight, setWeight] = useState('');
//   const [comment, setComment] = useState('');
//   const [images, setImages] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [errorMsg, setErrorMsg] = useState('');

//   const [sleepRating, setSleepRating] = useState(3);
//   const [nutritionRating, setNutritionRating] = useState(3);
//   const [motivationalRating, setMotivationalRating] = useState(3);
//   const [trainingRating, setTrainingRating] = useState(3);

//   const [uploadProgress, setUploadProgress] = useState(0);
// const [uploadPhase, setUploadPhase] = useState(''); // 'compress' | 'upload' | ''

//   const handleWeightChange = (e) => {
//     let value = e.target.value.replace(',', '.');
//     if (!/^\d*\.?\d*$/.test(value)) return;
//     if (value.includes('.')) {
//       const [, dec] = value.split('.');
//       if (dec && dec.length > 1) return;
//     }
//     setWeight(value);
//   };

//   const handleImageChange = (e) => {
//     setImages([...e.target.files]);
//   };

//   const resetForm = () => {
//     setWeight('');
//     setComment('');
//     setImages([]);
//     setSleepRating(3);
//     setNutritionRating(3);
//     setMotivationalRating(3);
//     setTrainingRating(3);
//     setErrorMsg('');
//     setUploadProgress(0);
//   setUploadPhase('');
//   };

//   const handleSubmit = async (e) => {
//     if (e && e.preventDefault) e.preventDefault();
//     if (isLoading) return;

//     setErrorMsg('');
//     setIsLoading(true);

//     try {

//       setUploadProgress(0);
//       setUploadPhase(images?.length ? 'compress' : '');   
//       // 1) Valider vekt
//       const weightValue = parseWeight(weight);

//       // 2) Last opp bilder (valgfritt) — egne kall til /upload
//       //const fileIds = await uploadImages(images);

//       // const fileIds = await uploadImages(images, {
//       //   compress: true,
//       //   compressOptions: { maxW: 1400, maxH: 1400, quality: 80 },
//       //   onProgress: (pct) => {
//       //     setUploadPhase('upload');
//       //     setUploadProgress(pct);
//       //   },
//       // });

//       const fileIds = await uploadImages(images, {
//   compress: true,
//   compressOptions: { maxW: 1400, maxH: 1400, quality: 80 },
//   onCompress: () => {
//     setUploadPhase('compress');
//     setUploadProgress(0);
//   },
//   onProgress: (pct) => {
//     setUploadPhase('upload');
//     setUploadProgress(pct);
//   },
// });


//       // 3) Opprett check-in med ren JSON-payload
//       const checkInPayload = {
//         data: {
//           client: userId,
//           coach: coachId || undefined,
//           weight: weightValue,
//           comment,
//           rating_training: trainingRating,
//           rating_nutrition: nutritionRating,
//           rating_motivation: motivationalRating,
//           rating_sleep: sleepRating,
//           date: new Date().toISOString(),
//           ...(fileIds.length > 0 ? { progress_pic: fileIds } : {}),
//         },
//       };

//       await axiosAuthFetch(`${API_BASE_URL}/check-ins`, checkInPayload, 'POST');

//       resetForm();
//       alert('✅ Check-in sendt inn!');

//       // Foretrekk callback over hard reload når mulig
//       if (typeof onSuccess === 'function') {
//         onSuccess();
//       } else {
//         window.location.reload();
//       }
//     } catch (error) {
//       console.error('Feil ved opprettelse av check-in:', error);

//       // Vis brukervenlig feil uten å lukke skjema
//       const serverMsg =
//         error?.response?.data?.error?.message ||
//         error?.response?.data?.message;
//       setErrorMsg(serverMsg || error?.message || 'Noe gikk galt. Prøv igjen.');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const LoadingOverlay = () => (
//     <div
//       style={{
//         position: 'absolute',
//         inset: 0,
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: 'rgba(255,255,255,0.75)',
//         zIndex: 10,
//         borderRadius: 12,
//       }}
//     >
//       <Loader />
//       {isLoading && images?.length > 0 && (
//           <div style={{ marginTop: 40 }}>
//             <div style={{ fontSize: 12, opacity: 0.7, marginBottom: 6 }}>
//               {uploadPhase === 'compress' ? 'Komprimerer bilder…' : `Laster opp bilder… ${uploadProgress}%`}
//             </div>

//             <div style={{ height: 10, background: '#eee', borderRadius: 999, overflow: 'hidden' }}>
//               <div
//                 style={{
//                   height: '100%',
//                   width: `${uploadProgress}%`,
//                   background: '#111',
//                   transition: 'width 150ms linear',
//                 }}
//               />
//             </div>
//           </div>
//         )}
//     </div>
//   );

//   return (
//     <div style={{ position: 'relative' }}>
//       {isLoading && <LoadingOverlay />}
//       <form className={css.form} onSubmit={handleSubmit}>
//         <h2>Ny Check-In</h2>

//         <div className={css.weightInput}>
//           <label>Vekt (i kg)</label>
//           <input
//             className={css.weightInputfield}
//             type="text"
//             inputMode="decimal"
//             value={weight}
//             onChange={handleWeightChange}
//             required
//             disabled={isLoading}
//             placeholder="f.eks. 82.5"
//           />
//         </div>

//         <div className={css.inputRating}>
//           <label>Søvn</label>
//           <StarRating rating={sleepRating} setRating={setSleepRating} disabled={isLoading} />
//         </div>
//         <div className={css.inputRating}>
//           <label>Trening</label>
//           <StarRating rating={trainingRating} setRating={setTrainingRating} disabled={isLoading} />
//         </div>
//         <div className={css.inputRating}>
//           <label>Kosthold</label>
//           <StarRating rating={nutritionRating} setRating={setNutritionRating} disabled={isLoading} />
//         </div>
//         <div className={css.inputRating}>
//           <label>Motivasjon</label>
//           <StarRating rating={motivationalRating} setRating={setMotivationalRating} disabled={isLoading} />
//         </div>

//         <div className={css.commentInput}>
//           <label>Kommentar</label>
//           <textarea
//             rows="5"
//             className={css.inputInput}
//             value={comment}
//             onChange={(e) => setComment(e.target.value)}
//             disabled={isLoading}
//           />
//         </div>

//         <div className={css.imageInput}>
//           <label>Last opp bilder (valgfritt):</label>
//           <input type="file" multiple onChange={handleImageChange} disabled={isLoading} />
//         </div>
        

//         {errorMsg && (
//           <div style={{ color: 'red', marginTop: 8, fontSize: 14 }}>
//             ⚠️ {errorMsg}
//           </div>
//         )}

//         <div style={{ marginTop: 10, fontSize: 12, opacity: 0.7 }}>
//           Når du trykker "Send inn" kan det ta et par sekunder – spesielt hvis du laster opp bilder.
//         </div>

//         <button
//           type="submit"
//           className={css.submitButton}
//           disabled={isLoading}
//           style={{ opacity: isLoading ? 0.7 : 1, marginTop: 16 }}
//         >
//           {isLoading ? 'Sender…' : 'SEND INN'}
//         </button>
//       </form>
//     </div>
//   );
// };

// // ---------------------------------------------------------------------------
// // NewCheckIn – frittstående modal-variant (brukes andre steder)
// // ---------------------------------------------------------------------------

// const NewCheckIn = ({ user }) => {
//   const userId = user.id;

//   const [weight, setWeight] = useState('');
//   const [comment, setComment] = useState('');
//   const [images, setImages] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [isError, setIsError] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const [sleepRating, setSleepRating] = useState(3);
//   const [nutritionRating, setNutritionRating] = useState(3);
//   const [motivationalRating, setMotivationalRating] = useState(3);
//   const [trainingRating, setTrainingRating] = useState(3);

//   const [uploadProgress, setUploadProgress] = useState(0);
// const [uploadPhase, setUploadPhase] = useState('');

//   const openModal = () => {
//     setIsError(false);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => setIsModalOpen(false);

//   const resetForm = () => {
//     setWeight('');
//     setComment('');
//     setImages([]);
//     setSleepRating(3);
//     setNutritionRating(3);
//     setMotivationalRating(3);
//     setTrainingRating(3);
//     setUploadProgress(0);
// setUploadPhase('');
//   };

//   const handleImageChange = (e) => setImages([...e.target.files]);

//   const handleWeightChange = (e) => {
//     let value = e.target.value.replace(',', '.');
//     if (!/^\d*\.?\d*$/.test(value)) return;
//     if (value.includes('.')) {
//       const [, dec] = value.split('.');
//       if (dec && dec.length > 1) return;
//     }
//     setWeight(value);
//   };

//   /**
//    * Returnerer true  → modal lukkes
//    * Returnerer false → modal forblir åpen (feil)
//    */
//   const handleSubmit = async () => {
//     if (isLoading) return false;

//     setIsError(false);
//     setIsLoading(true);

//     try {
//       const weightValue = parseWeight(weight);
//       //const fileIds = await uploadImages(images);
//       setUploadProgress(0);
//       setUploadPhase(images?.length ? 'compress' : '');

//       // const fileIds = await uploadImages(images, {
//       //   compress: true,
//       //   compressOptions: { maxW: 1400, maxH: 1400, quality: 80 },
//       //   onProgress: (pct) => {
//       //     setUploadPhase('upload');
//       //     setUploadProgress(pct);
//       //   },
//       // });
//       const fileIds = await uploadImages(images, {
//   compress: true,
//   compressOptions: { maxW: 1400, maxH: 1400, quality: 80 },
//   onCompress: () => {
//     setUploadPhase('compress');
//     setUploadProgress(0);
//   },
//   onProgress: (pct) => {
//     setUploadPhase('upload');
//     setUploadProgress(pct);
//   },
// });

//       const checkInPayload = {
//         data: {
//           client: userId,
//           weight: weightValue,
//           comment,
//           rating_training: trainingRating,
//           rating_nutrition: nutritionRating,
//           rating_motivation: motivationalRating,
//           rating_sleep: sleepRating,
//           date: new Date().toISOString(),
//           ...(fileIds.length > 0 ? { progress_pic: fileIds } : {}),
//         },
//       };

//       await axiosAuthFetch(`${API_BASE_URL}/check-ins`, checkInPayload, 'POST');

//       resetForm();
//       return true; // lukk modal
//     } catch (error) {
//       console.error('Feil ved opprettelse av check-in:', error);
//       setIsError(true);
//       return false;
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className={css.container}>
//       <button className={css.submitButton} onClick={openModal}>
//         Ny Check-In
//       </button>

//       <CustomAlertModal
//         show={isModalOpen}
//         handleClose={closeModal}
//         modalTitle="Hvordan har din uke vært?"
//         buttonLabel={isLoading ? 'Sender…' : 'Send inn'}
//         submit={handleSubmit}
//         content={
//           <div className={css.form}>
//             <div className={css.weightInput}>
//               <label>Vekt (i kg)</label>
//               <input
//                 className={css.weightInputfield}
//                 type="text"
//                 inputMode="decimal"
//                 value={weight}
//                 onChange={handleWeightChange}
//                 required
//                 disabled={isLoading}
//                 placeholder="f.eks. 82.5"
//               />
//             </div>

//             <div className={css.inputRating}>
//               <label>Søvn</label>
//               <StarRating rating={sleepRating} setRating={setSleepRating} disabled={isLoading} />
//             </div>
//             <div className={css.inputRating}>
//               <label>Trening</label>
//               <StarRating rating={trainingRating} setRating={setTrainingRating} disabled={isLoading} />
//             </div>
//             <div className={css.inputRating}>
//               <label>Kosthold</label>
//               <StarRating rating={nutritionRating} setRating={setNutritionRating} disabled={isLoading} />
//             </div>
//             <div className={css.inputRating}>
//               <label>Motivasjon</label>
//               <StarRating rating={motivationalRating} setRating={setMotivationalRating} disabled={isLoading} />
//             </div>

//             <div className={css.commentInput}>
//               <label>Kommentar</label>
//               <textarea
//                 rows="5"
//                 className={css.inputInput}
//                 value={comment}
//                 onChange={(e) => setComment(e.target.value)}
//                 disabled={isLoading}
//               />
//             </div>

//             <div className={css.imageInput}>
//               <label>Last opp bilder (valgfritt):</label>
//               <input type="file" multiple onChange={handleImageChange} disabled={isLoading} />
//             </div>

//             {isError && (
//               <div style={{ color: 'red', marginTop: 8 }}>
//                 ⚠️ Noe gikk galt. Sjekk nettverkstilkoblingen og prøv igjen.
//               </div>
//             )}

//             <div style={{ marginTop: 10, fontSize: 12, opacity: 0.7 }}>
//               Når du trykker "Send inn" kan det ta et par sekunder – spesielt hvis du laster opp bilder.
//             </div>

//             {isLoading && images?.length > 0 && (
//           <div style={{ marginTop: 10 }}>
//             <div style={{ fontSize: 12, opacity: 0.7, marginBottom: 6 }}>
//               {uploadPhase === 'compress' ? 'Komprimerer bilder…' : `Laster opp bilder… ${uploadProgress}%`}
//             </div>

//             <div style={{ height: 10, background: '#eee', borderRadius: 999, overflow: 'hidden' }}>
//               <div
//                 style={{
//                   height: '100%',
//                   width: `${uploadProgress}%`,
//                   background: '#111',
//                   transition: 'width 150ms linear',
//                 }}
//               />
//             </div>
//           </div>
//         )}
//           </div>
//         }
//       />
//     </div>
//   );
// };

// export default NewCheckIn;



import React, { useState } from 'react';
import css from './check-in.module.css';
import { axiosImageAuthFetch, axiosAuthFetch } from '../../../../helpers/axios';
import { API_BASE_URL } from '../../../../constants';
import Loader from '../../loader';
import CustomAlertModal from '../../customModal';
import Resizer from 'react-image-file-resizer';

// ---------------------------------------------------------------------------
// Image compression helpers
// ---------------------------------------------------------------------------

function resizeToJpegFile(file, { maxW = 1400, maxH = 1400, quality = 80 } = {}) {
  return new Promise((resolve, reject) => {
    try {
      Resizer.imageFileResizer(
        file,
        maxW,
        maxH,
        'JPEG',
        quality,
        0,
        (uri) => resolve(uri),
        'file',
        file.name?.replace(/\.\w+$/, '') || 'image'
      );
    } catch (e) {
      reject(e);
    }
  });
}

async function compressImages(images, opts) {
  if (!images || images.length === 0) return [];
  return Promise.all(images.map((f) => resizeToJpegFile(f, opts)));
}

async function uploadImages(images, {
  onProgress,
  onCompress,
  compress = true,
  compressOptions = { maxW: 1400, maxH: 1400, quality: 80 },
} = {}) {
  if (!images || images.length === 0) return [];

  // 1) Komprimer
  onCompress?.();
  const finalFiles = compress
    ? await compressImages(images, compressOptions)
    : images;

  // 2) Last opp
  onProgress?.(0);
  const uploadFormData = new FormData();
  finalFiles.forEach((img) => uploadFormData.append('files', img));

  const uploadResponse = await axiosImageAuthFetch(
    `${API_BASE_URL}/upload`,
    uploadFormData,
    'POST',
    {
      onUploadProgress: (evt) => {
        if (!evt.total) return;
        const pct = Math.round((evt.loaded / evt.total) * 100);
        onProgress?.(pct);
      },
    }
  );

  const filesArray = Array.isArray(uploadResponse)
    ? uploadResponse
    : Array.isArray(uploadResponse?.data)
    ? uploadResponse.data
    : [];

  onProgress?.(100);
  return filesArray.map((f) => f.id);
}

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------

const StarRating = ({ rating, setRating, disabled }) => (
  <div className={css.stars}>
    {[...Array(5)].map((_, index) => (
      <span
        key={index}
        className={`${css.star} ${index < rating ? css.filled : ''}`}
        onClick={() => !disabled && setRating(index + 1)}
        role="button"
        tabIndex={disabled ? -1 : 0}
        onKeyDown={(e) => {
          if (!disabled && (e.key === 'Enter' || e.key === ' ')) setRating(index + 1);
        }}
        aria-label={`Sett rating til ${index + 1} av 5`}
      >
        ★
      </span>
    ))}
  </div>
);

function parseWeight(rawValue) {
  const str = (rawValue ?? '').replace(',', '.').trim();
  const num = parseFloat(str);
  if (!str || isNaN(num) || num <= 0) {
    throw new Error('Vennligst skriv inn en gyldig vekt (f.eks. 82.5)');
  }
  return parseFloat(num.toFixed(1));
}

// ---------------------------------------------------------------------------
// CheckInForm – brukes fra profil-siden (BottomSheetModal)
// ---------------------------------------------------------------------------

export const CheckInForm = ({ user, coachId, checkIns, onSuccess }) => {
  const userId = user.id;

  const [weight, setWeight] = useState('');
  const [comment, setComment] = useState('');
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadPhase, setUploadPhase] = useState('');

  const [sleepRating, setSleepRating] = useState(3);
  const [nutritionRating, setNutritionRating] = useState(3);
  const [motivationalRating, setMotivationalRating] = useState(3);
  const [trainingRating, setTrainingRating] = useState(3);

  const handleWeightChange = (e) => {
    let value = e.target.value.replace(',', '.');
    if (!/^\d*\.?\d*$/.test(value)) return;
    if (value.includes('.')) {
      const [, dec] = value.split('.');
      if (dec && dec.length > 1) return;
    }
    setWeight(value);
  };

  const handleImageChange = (e) => {
    setImages([...e.target.files]);
  };

  const resetForm = () => {
    setWeight('');
    setComment('');
    setImages([]);
    setSleepRating(3);
    setNutritionRating(3);
    setMotivationalRating(3);
    setTrainingRating(3);
    setErrorMsg('');
    setUploadProgress(0);
    setUploadPhase('');
  };

  const handleSubmit = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (isLoading) return;

    setErrorMsg('');
    setIsLoading(true);

    try {
      const weightValue = parseWeight(weight);

      const fileIds = await uploadImages(images, {
        compress: true,
        compressOptions: { maxW: 1400, maxH: 1400, quality: 80 },
        onCompress: () => {
          setUploadPhase('compress');
          setUploadProgress(0);
        },
        onProgress: (pct) => {
          setUploadPhase('upload');
          setUploadProgress(pct);
        },
      });

      const checkInPayload = {
        data: {
          client: userId,
          coach: coachId || undefined,
          weight: weightValue,
          comment,
          rating_training: trainingRating,
          rating_nutrition: nutritionRating,
          rating_motivation: motivationalRating,
          rating_sleep: sleepRating,
          date: new Date().toISOString(),
          ...(fileIds.length > 0 ? { progress_pic: fileIds } : {}),
        },
      };

      await axiosAuthFetch(`${API_BASE_URL}/check-ins`, checkInPayload, 'POST');

      resetForm();
      alert('✅ Check-in sendt inn!');

      if (typeof onSuccess === 'function') {
        onSuccess();
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error('Feil ved opprettelse av check-in:', error);
      const serverMsg =
        error?.response?.data?.error?.message ||
        error?.response?.data?.message;
      setErrorMsg(serverMsg || error?.message || 'Noe gikk galt. Prøv igjen.');
    } finally {
      setIsLoading(false);
    }
  };

  const LoadingOverlay = () => (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(255,255,255,0.85)',
        zIndex: 10,
        borderRadius: 12,
        padding: 24,
      }}
    >
      <Loader />
      {images?.length > 0 && (
        <div style={{ marginTop: 20, width: '80%' }}>
          <div style={{ fontSize: 13, opacity: 0.7, marginBottom: 8, textAlign: 'center' }}>
            {uploadPhase === 'compress'
              ? 'Komprimerer bilder…'
              : `Laster opp bilder… ${uploadProgress}%`}
          </div>
          <div style={{ height: 8, background: '#eee', borderRadius: 999, overflow: 'hidden' }}>
            <div
              style={{
                height: '100%',
                width: `${uploadPhase === 'compress' ? 0 : uploadProgress}%`,
                background: '#111',
                transition: 'width 150ms linear',
              }}
            />
          </div>
        </div>
      )}
    </div>
  );

  return (
    <div style={{ position: 'relative' }}>
      {isLoading && <LoadingOverlay />}
      <form className={css.form} onSubmit={handleSubmit}>
        <h2>Ny Check-In</h2>

        <div className={css.weightInput}>
          <label>Vekt (i kg)</label>
          <input
            className={css.weightInputfield}
            type="text"
            inputMode="decimal"
            value={weight}
            onChange={handleWeightChange}
            required
            disabled={isLoading}
            placeholder="f.eks. 82.5"
          />
        </div>

        <div className={css.inputRating}>
          <label>Søvn</label>
          <StarRating rating={sleepRating} setRating={setSleepRating} disabled={isLoading} />
        </div>
        <div className={css.inputRating}>
          <label>Trening</label>
          <StarRating rating={trainingRating} setRating={setTrainingRating} disabled={isLoading} />
        </div>
        <div className={css.inputRating}>
          <label>Kosthold</label>
          <StarRating rating={nutritionRating} setRating={setNutritionRating} disabled={isLoading} />
        </div>
        <div className={css.inputRating}>
          <label>Motivasjon</label>
          <StarRating rating={motivationalRating} setRating={setMotivationalRating} disabled={isLoading} />
        </div>

        <div className={css.commentInput}>
          <label>Kommentar</label>
          <textarea
            rows="5"
            className={css.inputInput}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            disabled={isLoading}
          />
        </div>

        <div className={css.imageInput}>
          <label>Last opp bilder (valgfritt):</label>
          <input type="file" multiple onChange={handleImageChange} disabled={isLoading} accept="image/*" />
        </div>

        {errorMsg && (
          <div style={{ color: 'red', marginTop: 8, fontSize: 14 }}>
            ⚠️ {errorMsg}
          </div>
        )}

        <button
          type="submit"
          className={css.submitButton}
          disabled={isLoading}
          style={{ opacity: isLoading ? 0.7 : 1, marginTop: 16 }}
        >
          {isLoading ? 'Sender…' : 'SEND INN'}
        </button>
      </form>
    </div>
  );
};

// ---------------------------------------------------------------------------
// NewCheckIn – frittstående modal-variant (brukes andre steder)
// ---------------------------------------------------------------------------

const NewCheckIn = ({ user }) => {
  const userId = user.id;

  const [weight, setWeight] = useState('');
  const [comment, setComment] = useState('');
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadPhase, setUploadPhase] = useState('');

  const [sleepRating, setSleepRating] = useState(3);
  const [nutritionRating, setNutritionRating] = useState(3);
  const [motivationalRating, setMotivationalRating] = useState(3);
  const [trainingRating, setTrainingRating] = useState(3);

  const openModal = () => {
    setIsError(false);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const resetForm = () => {
    setWeight('');
    setComment('');
    setImages([]);
    setSleepRating(3);
    setNutritionRating(3);
    setMotivationalRating(3);
    setTrainingRating(3);
    setUploadProgress(0);
    setUploadPhase('');
  };

  const handleImageChange = (e) => setImages([...e.target.files]);

  const handleWeightChange = (e) => {
    let value = e.target.value.replace(',', '.');
    if (!/^\d*\.?\d*$/.test(value)) return;
    if (value.includes('.')) {
      const [, dec] = value.split('.');
      if (dec && dec.length > 1) return;
    }
    setWeight(value);
  };

  const handleSubmit = async () => {
    if (isLoading) return false;

    setIsError(false);
    setIsLoading(true);

    try {
      const weightValue = parseWeight(weight);

      const fileIds = await uploadImages(images, {
        compress: true,
        compressOptions: { maxW: 1400, maxH: 1400, quality: 80 },
        onCompress: () => {
          setUploadPhase('compress');
          setUploadProgress(0);
        },
        onProgress: (pct) => {
          setUploadPhase('upload');
          setUploadProgress(pct);
        },
      });

      const checkInPayload = {
        data: {
          client: userId,
          weight: weightValue,
          comment,
          rating_training: trainingRating,
          rating_nutrition: nutritionRating,
          rating_motivation: motivationalRating,
          rating_sleep: sleepRating,
          date: new Date().toISOString(),
          ...(fileIds.length > 0 ? { progress_pic: fileIds } : {}),
        },
      };

      await axiosAuthFetch(`${API_BASE_URL}/check-ins`, checkInPayload, 'POST');

      resetForm();
      return true;
    } catch (error) {
      console.error('Feil ved opprettelse av check-in:', error);
      setIsError(true);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={css.container}>
      <button className={css.submitButton} onClick={openModal}>
        Ny Check-In
      </button>

      <CustomAlertModal
        show={isModalOpen}
        handleClose={closeModal}
        modalTitle="Hvordan har din uke vært?"
        buttonLabel={isLoading ? 'Sender…' : 'Send inn'}
        submit={handleSubmit}
        content={
          <div className={css.form}>
            <div className={css.weightInput}>
              <label>Vekt (i kg)</label>
              <input
                className={css.weightInputfield}
                type="text"
                inputMode="decimal"
                value={weight}
                onChange={handleWeightChange}
                required
                disabled={isLoading}
                placeholder="f.eks. 82.5"
              />
            </div>

            <div className={css.inputRating}>
              <label>Søvn</label>
              <StarRating rating={sleepRating} setRating={setSleepRating} disabled={isLoading} />
            </div>
            <div className={css.inputRating}>
              <label>Trening</label>
              <StarRating rating={trainingRating} setRating={setTrainingRating} disabled={isLoading} />
            </div>
            <div className={css.inputRating}>
              <label>Kosthold</label>
              <StarRating rating={nutritionRating} setRating={setNutritionRating} disabled={isLoading} />
            </div>
            <div className={css.inputRating}>
              <label>Motivasjon</label>
              <StarRating rating={motivationalRating} setRating={setMotivationalRating} disabled={isLoading} />
            </div>

            <div className={css.commentInput}>
              <label>Kommentar</label>
              <textarea
                rows="5"
                className={css.inputInput}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                disabled={isLoading}
              />
            </div>

            <div className={css.imageInput}>
              <label>Last opp bilder (valgfritt):</label>
              <input type="file" multiple onChange={handleImageChange} disabled={isLoading} accept="image/*" />
            </div>

            {isError && (
              <div style={{ color: 'red', marginTop: 8 }}>
                ⚠️ Noe gikk galt. Sjekk nettverkstilkoblingen og prøv igjen.
              </div>
            )}

            {isLoading && images?.length > 0 && (
              <div style={{ marginTop: 10 }}>
                <div style={{ fontSize: 12, opacity: 0.7, marginBottom: 6 }}>
                  {uploadPhase === 'compress'
                    ? 'Komprimerer bilder…'
                    : `Laster opp bilder… ${uploadProgress}%`}
                </div>
                <div style={{ height: 8, background: '#eee', borderRadius: 999, overflow: 'hidden' }}>
                  <div
                    style={{
                      height: '100%',
                      width: `${uploadPhase === 'compress' ? 0 : uploadProgress}%`,
                      background: '#111',
                      transition: 'width 150ms linear',
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        }
      />
    </div>
  );
};

export default NewCheckIn;